<template>
    <div class="card">
        <div class="bg-dark card-header text-white">Academic Indirect Cost Distribution - By Account</div>
        <div class="card-body">
            <div v-if="!isLoading" class="table-responsive">
                <table class="table table-sm">
                    <thead>
                        <tr>
                            <th style="width: 100px !important;"></th>
                            <th style="width: 100px !important;">SL</th>
                            <th>SA</th>
                            <th>Responsible Person</th>
                            <th>TTI Department</th>
                            <th>Start Date</th>
                            <th>Distribution</th>
                            <th>IDC Rate (%)</th>
                            <th style="width: 100px !important;text-align:end;">Total Amount Paid</th>
                            <th style="width: 100px !important;text-align:end;">Total IDC Credit</th>
                            <th style="width: 100px !important;text-align:end;">Total Department IDC Credit</th>
                            <th style="width: 100px !important;text-align:end;">Total PI IDC Credit</th>
                            <th style="width: 100px !important;text-align:end;">Total RDF Credit</th>
                        </tr>
                  </thead>
                  <tbody>
                      <template v-for="(account, index) in accounts">
                        <tr :key="index">
                          <td>
                            <div class="row">
                              <div class="col-4 col-lg-3">
                                <a @click="togglePayees(index)" class="ml-3">
                                  <i v-if="!account.showPayees" class="fa fa-caret-down fa-lg" />
                                  <i v-if="account.showPayees" class="fa fa-caret-up fa-lg" />
                                </a>
                              </div>
                            </div>
                          </td>
                          <td>{{ account.sl }}</td>
                          <td>{{ account.sa }}</td>
                          <td>{{ account.responsiblePersonName }}</td>
                          <td>{{ account.ttiDepartment }}</td>
                          <td>{{ account.startDate | moment('MM/DD/YYYY') }}</td>
                          <td>{{ account.distribution }}</td>
                          <td>{{ account.indirectCostRate }}</td>
                          <td style="text-align:end;">{{ account.amountPaid | currency }}</td>
                          <td style="text-align:end;">{{ account.idcCredit | currency }}</td>
                          <td style="text-align:end;">{{ account.departmentIDCCredit | currency }}</td>
                          <td style="text-align:end;">{{ account.piidcCredit | currency }}</td>
                          <td style="text-align:end;">{{ account.rdfCredit | currency }}</td>
                        </tr>
                        <tr v-if="account.showPayees" :key="index">
                          <td colspan="2"></td>
                          <td colspan="11">
                            <table class="table table-sm payees-table">
                              <thead>
                                <tr>
                                  <th style="width: 100px !important;"></th>
                                  <th>Payee UIN</th>
                                  <th>Payee</th>
                                  <th>Title Level</th>
                                  <th>Title Code</th>
                                  <th>Title</th>
                                  <th>Payroll Entry Date</th>
                                  <th style="width: 100px !important;text-align:end;">Amount Paid</th>
                                  <th style="width: 100px !important;text-align:end;">IDC Credit</th>
                                  <th style="width: 100px !important;text-align:end;">Department IDC Credit</th>
                                  <th style="width: 100px !important;text-align:end;">PI IDC Credit</th>
                                  <th style="width: 100px !important;text-align:end;">RDF Credit</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="payee in account.payees" :key="payee">
                                  <td>
                                    <div class="btn-group col-auto ml-2">
                                        <button v-if="canEdit" @click="onEditPayee(account, payee)" class="btn btn-warning btn-sm d-print-none" title="Edit Payee"
                                                type="button"><i class="fa fa-pencil-alt"></i>
                                        </button>
                                    </div>
                                  </td>
                                  <td>{{ payee.payeeUIN }}</td>
                                  <td>{{ payee.payeeName }}</td>
                                  <td>{{ payee.payeeTitleLevel }}</td>
                                  <td>{{ payee.payeeTitleCode }}</td>
                                  <td>{{ payee.payeeTitle }}</td>
                                  <td>{{ payee.payrollEntryDate | moment('MM/DD/YYYY') }}</td>
                                  <td style="text-align:end;">{{ payee.amountPaid | currency }}</td>
                                  <td style="text-align:end;">{{ payee.idcCredit | currency }}</td>
                                  <td style="text-align:end;">{{ payee.departmentIDCCredit | currency }}</td>
                                  <td style="text-align:end;">{{ payee.piidcCredit | currency }}</td>
                                  <td style="text-align:end;">{{ payee.rdfCredit | currency }}</td>
                                </tr>
                                <tr>
                                  <td colspan="7" style="font-weight: bold;text-align:end;">Total</td>
                                  <td style="font-weight: bold;border-top: 3px double;border-bottom: 3px double;text-align:end;">{{ account.amountPaid | currency }}</td>
                                  <td style="font-weight: bold;border-top: 3px double;border-bottom: 3px double;text-align:end;">{{ account.idcCredit | currency }}</td>
                                  <td style="font-weight: bold;border-top: 3px double;border-bottom: 3px double;text-align:end;">{{ account.departmentIDCCredit | currency }}</td>
                                  <td style="font-weight: bold;border-top: 3px double;border-bottom: 3px double;text-align:end;">{{ account.piidcCredit | currency }}</td>
                                  <td style="font-weight: bold;border-top: 3px double;border-bottom: 3px double;text-align:end;">{{ account.rdfCredit | currency }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </template>
                      <tr>
                        <td colspan="8" style="font-weight: bold;text-align:end;">Total</td>
                        <td style="font-weight: bold;border-top: 3px double;border-bottom: 3px double;text-align:end;">{{ totalAmountPaid | currency }}</td>
                        <td style="font-weight: bold;border-top: 3px double;border-bottom: 3px double;text-align:end;">{{ totalIDCCredit | currency }}</td>
                        <td style="font-weight: bold;border-top: 3px double;border-bottom: 3px double;text-align:end;">{{ totalDepartmentIDCCredit | currency }}</td>
                        <td style="font-weight: bold;border-top: 3px double;border-bottom: 3px double;text-align:end;">{{ totalPIIDCCredit | currency }}</td>
                        <td style="font-weight: bold;border-top: 3px double;border-bottom: 3px double;text-align:end;">{{ totalRDFCredit | currency }}</td>
                      </tr>
                  </tbody>
                </table>
            </div>
        </div>
        <AppModal @close="onEditPayeeClose()" v-if="isEditModalVisible">
            <template v-slot:header>Edit Payee</template>
            <form @submit.prevent="onEditPayeeSubmit()">
                <transition name="fade">
                    <AppNotification :type="alertMessage.type" v-if="alertMessage.message">
                        {{alertMessage.message}}
                    </AppNotification>
                </transition>
                <div class="form-group">
                    <label for="newPayeeName">Name</label>
                    <input :class="{'is-invalid': $v.newPayeeName.$invalid}" class="form-control" v-model="newPayeeName" />
                    <span class="invalid-feedback" v-if="!$v.newPayeeName.required">Field is required</span>
                </div>
                <div class="form-group">
                    <label for="newPayeeUIN">UIN</label>
                    <input :class="{'is-invalid': $v.newPayeeUIN.$invalid}" class="form-control" v-model="newPayeeUIN" />
                    <span class="invalid-feedback" v-if="!$v.newPayeeUIN.required">Field is required</span>
                </div>
                <div class="form-group">
                    <label for="newPayeeTitleLevel">Title Level</label>
                    <input :class="{'is-invalid': $v.newPayeeTitleLevel.$invalid}" class="form-control" v-model="newPayeeTitleLevel" />
                    <span class="invalid-feedback" v-if="!$v.newPayeeTitleLevel.required">Field is required</span>
                </div>
                <div class="form-group">
                    <label for="newPayeeTitleCode">Title Code</label>
                    <input :class="{'is-invalid': $v.newPayeeTitleCode.$invalid}" class="form-control" v-model="newPayeeTitleCode" />
                    <span class="invalid-feedback" v-if="!$v.newPayeeTitleCode.required">Field is required</span>
                </div>
                <div class="form-group">
                    <label for="newPayeeTitle">Title</label>
                    <input :class="{'is-invalid': $v.newPayeeTitle.$invalid}" class="form-control" v-model="newPayeeTitle" />
                    <span class="invalid-feedback" v-if="!$v.newPayeeTitle.required">Field is required</span>
                </div>
            </form>
            <template v-slot:footer>
                <button :disabled="isSubmitting" @click.prevent="onEditPayeeSubmit()" class="btn btn-primary" type="submit">Save
                </button>
                <button :disabled="isSubmitting" @click="onEditPayeeClose()" class="btn btn-danger" data-dismiss="modal"
                        type="button">
                    Close
                </button>
            </template>
        </AppModal>
    </div>
</template>

<script>
    import AcademicIndirectCostService from "../../services/AcademicIndirectCostService";
    import { currency } from "../../filters/Currency";
    import AppModal from "@/components/shared/AppModal.vue"
    import {ToastType} from "@/services/models/shared/ToastType";
    import {required} from "vuelidate/lib/validators";

    export default {
      components: {
        AppModal
      },
        props: {
          adLoc: {
            required: true,
            type: String
          },
          fiscalYear: {
            required: true,
            type: Number
          },
          payPeriodStartDate: {
            required: true,
            type: Date
          },
          canEdit: {
            required: true,
            type: Boolean
          },
          departmentName: {
            required: true,
            type: String
          }
        },
        filters: {
            currency
        },
        data() {
            return {
                accounts: [],
                isLoading: false,
                filterOptions: {
                  payPeriodStartDate: null,
                  adLoc: null
                },
                sl: null,
                sa: null,
                responsiblePersonName: null,
                responsiblePersonUIN: null,
                ttiDepartment: null,
                startDate: null,
                distribution: null,
                indirectCostRate: null,
                payrollEntryDate: null,
                previousPayeeName: null,
                previousPayeeUIN: null,
                previousPayeeTitleLevel: null,
                previousPayeeTitleCode:  null,
                previousPayeeTitle: null,
                newPayeeName: null,
                newPayeeUIN: null,
                newPayeeTitleLevel: null,
                newPayeeTitleCode: null,
                newPayeeTitle: null,
                isEditModalVisible: false,
                alertMessage: {
                    type: null,
                    message: null
                },
                isSubmitting: false
            }
        },
        computed: {
          totalAmountPaid() {
            return this.accounts.map((obj) => { return obj.amountPaid }).reduce((accumulator, currentValue) => accumulator + currentValue, 0);
          },

          totalIDCCredit() {
            return this.accounts.map((obj) => { return obj.idcCredit }).reduce((accumulator, currentValue) => accumulator + currentValue, 0);
          },

          totalDepartmentIDCCredit() {
            return this.accounts.map((obj) => { return obj.departmentIDCCredit }).reduce((accumulator, currentValue) => accumulator + currentValue, 0);
          },

          totalPIIDCCredit() {
            return this.accounts.map((obj) => { return obj.piidcCredit }).reduce((accumulator, currentValue) => accumulator + currentValue, 0);
          },

          totalRDFCredit() {
            return this.accounts.map((obj) => { return obj.rdfCredit }).reduce((accumulator, currentValue) => accumulator + currentValue, 0);
          }
        },
        methods: {
            /**
             * @description Loads the data from the API
             */
            loadData() {
                const vm = this;
                vm.isLoading = true;

                AcademicIndirectCostService.getAccountPayees(vm.filterOptions)
                    .then(response => {
                        vm.accounts = response.map((obj) => { return {...obj, showPayees: false }});
                    })
                    .catch(() => {
                        vm.redirectToError()
                    })
                    .finally(() => {
                        vm.isLoading = false;
                    })
            },
            
            togglePayees (index) {
              this.accounts[index].showPayees = !this.accounts[index].showPayees;
            },

            onEditPayee (account, payee) {
              this.sl = account.sl;
              this.sa = account.sa;
              this.responsiblePersonName = account.responsiblePersonName;
              this.responsiblePersonUIN = account.responsiblePersonUIN;
              this.ttiDepartment = account.ttiDepartment;
              this.startDate = account.startDate;
              this.distribution = account.distribution;
              this.indirectCostRate = account.indirectCostRate;
              this.payrollEntryDate = payee.payrollEntryDate;
              this.previousPayeeName = payee.payeeName;
              this.previousPayeeUIN = payee.payeeUIN;
              this.previousPayeeTitleLevel = payee.payeeTitleLevel;
              this.previousPayeeTitleCode = payee.payeeTitleCode;
              this.previousPayeeTitle = payee.payeeTitle;
              this.newPayeeName = payee.payeeName;
              this.newPayeeUIN = payee.payeeUIN;
              this.newPayeeTitleLevel = payee.payeeTitleLevel;
              this.newPayeeTitleCode = payee.payeeTitleCode;
              this.newPayeeTitle = payee.payeeTitle;
              this.isEditModalVisible = true;
            },

            onEditPayeeClose () {
              this.sl = null;
              this.sa = null;
              this.responsiblePersonName = null;
              this.responsiblePersonUIN = null;
              this.ttiDepartment = null;
              this.startDate = null;
              this.distribution = null;
              this.indirectCostRate = null;
              this.payrollEntryDate = null;
              this.previousPayeeName = null;
              this.previousPayeeUIN = null;
              this.previousPayeeTitleLevel = null;
              this.previousPayeeTitleCode = null;
              this.previousPayeeTitle = null;
              this.newPayeeName = null;
              this.newPayeeUIN = null;
              this.newPayeeTitleLevel = null;
              this.newPayeeTitleCode = null;
              this.newPayeeTitle = null;
              this.isEditModalVisible = false;
            },

            onEditPayeeSubmit() {
                const vm = this;

                // stop here if form is invalid
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                vm.isSubmitting = true;
                AcademicIndirectCostService.updatePayee({
                    payPeriodStartDate: this.payPeriodStartDate,
                    adLoc: this.adLoc,
                    sl: this.sl,
                    sa: this.sa,
                    responsiblePersonName: this.responsiblePersonName,
                    responsiblePersonUIN: this.responsiblePersonUIN,
                    ttiDepartment: this.ttiDepartment,
                    startDate: this.startDate,
                    distribution: this.distribution,
                    indirectCostRate: this.indirectCostRate,
                    payrollEntryDate: this.payrollEntryDate,
                    previousPayeeName: this.previousPayeeName,
                    previousPayeeUIN: this.previousPayeeUIN,
                    previousPayeeTitleLevel: this.previousPayeeTitleLevel,
                    previousPayeeTitleCode: this.previousPayeeTitleCode,
                    previousPayeeTitle: this.previousPayeeTitle,
                    newPayeeName: this.newPayeeName,
                    newPayeeUIN: this.newPayeeUIN,
                    newPayeeTitleLevel: this.newPayeeTitleLevel,
                    newPayeeTitleCode: this.newPayeeTitleCode,
                    newPayeeTitle: this.newPayeeTitle
                }).then(() => {
                    vm.alert(ToastType.Success, `PI information was updated successfully`);
                    vm.onEditPayeeClose();
                    vm.loadData();
                }).catch(function (error) {
                    vm.alertMessage.type = "danger";
                    vm.alertMessage.message = error.response.statusText;
                }).finally(() => {
                    vm.isSubmitting = false;
                });
            }
        },
        created() {
            this.filterOptions.payPeriodStartDate = this.payPeriodStartDate;
            this.filterOptions.adLoc = this.adLoc;
            this.loadData();
        },
        validations: {
            newPayeeName: {
              required
            },
            newPayeeUIN: {
              required
            },
            newPayeeTitleLevel: {
              required
            },
            newPayeeTitleCode: {
              required
            },
            newPayeeTitle: {
              required
            }
        }
    }
</script>
  
<style scoped>
  table.payees-table {
    background-color: rgba(0,0,0,.05) !important;
  }
</style>